import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './styles.css';

const staleChunkReloadKey = 'shx-office-stale-chunk-reload-at';

class RootErrorBoundary extends React.Component<React.PropsWithChildren, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    if (this.state.failed) {
      return <main className="login-shell"><section className="login-card">
        <div className="login-form">
          <span className="eyebrow">SHX Office</span>
          <h2>Stránku je potřeba obnovit</h2>
          <p>Mezitím byla nasazena nová verze aplikace.</p>
          <button className="button primary" onClick={() => window.location.reload()}>Načíst aktuální verzi</button>
        </div>
      </section></main>;
    }
    return this.props.children;
  }
}

// A user can keep Office open while a new immutable bundle is deployed. If a
// lazy module from the previous release no longer exists, Vite emits this event
// before React renders the import error. Reload once to obtain the current HTML
// and bundle map instead of leaving the application as a blank page.
window.addEventListener('vite:preloadError', event => {
  event.preventDefault();
  const lastReloadAt = Number(sessionStorage.getItem(staleChunkReloadKey) || 0);
  if (Date.now() - lastReloadAt < 60_000) return;
  sessionStorage.setItem(staleChunkReloadKey, String(Date.now()));
  window.location.reload();
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RootErrorBoundary><App /></RootErrorBoundary>
  </React.StrictMode>,
);
